import { render, staticRenderFns } from "./FormDataLayer.vue?vue&type=template&id=65d2f348&"
import script from "./FormDataLayer.vue?vue&type=script&lang=js&"
export * from "./FormDataLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d2f348')) {
      api.createRecord('65d2f348', component.options)
    } else {
      api.reload('65d2f348', component.options)
    }
    module.hot.accept("./FormDataLayer.vue?vue&type=template&id=65d2f348&", function () {
      api.rerender('65d2f348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormDataLayer.vue"
export default component.exports